module.exports = __webpack_public_path__ + "img/pt.43a32a1c.svg";